import { defaultDisabilityPhysicianFormValues, DisabilityPhysicianFormValues } from "./DisabilityPhysicianFormValues";
import { Mood } from "../enums/Mood";
import { Affect } from "../enums/Affect";
import { PsychomotorActivity } from "../enums/PsychomotorActivity";
import { Orientation } from "../enums/Orientation";
import { Concentration } from "../enums/Concentration";
import { Memory } from "../enums/Memory";
import { ConditionType } from "../enums/ConditionType";
import { SicknessType } from "../enums/SicknessType";

export type MentalHealthDisabilityPhysicianFormValues = DisabilityPhysicianFormValues & {
    mood: Mood,
    affect: Affect,
    psychomotorActivity: PsychomotorActivity,
    orientation: Orientation[],
    concentration: Concentration,
    memory: Memory,
    suicidal: string,
    visitFrequency: string,
    restrictedJobDuties: string,
    restrictedPhysical: string,
    restrictedFamily: string,
    restrictedSocial: string,
    restrictedDailyLiving: string,
    workForDifferentEmployer: string,
    returnToWorkTreatmentPlan: string
}

export const defaultMentalHealthDisabilityPhysicianFormValues = {
    ...defaultDisabilityPhysicianFormValues,
    conditionType: ConditionType.SICKNESS,
    sicknessType: SicknessType.MENTAL_HEALTH,
    mood: '',
    affect: '',
    psychomotorActivity: '',
    orientation: [],
    concentration: '',
    memory: '',
    suicidal: '',
    visitFrequency: '',
    restrictedJobDuties: '',
    restrictedPhysical: '',
    restrictedFamily: '',
    restrictedSocial: '',
    restrictedDailyLiving: '',
    workForDifferentEmployer: '',
    returnToWorkTreatmentPlan: ''
}